/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';

export default function createResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        creatingStatus: FETCH_STATUSES.idle,
        errors: null,
      },
    },
    reducers: {
      createResourceStart(state) {
        state[resource].creatingStatus = FETCH_STATUSES.pending;
        state[resource].errors = null;
      },
      createResourceSuccess(state) {
        state[resource].creatingStatus = FETCH_STATUSES.fulfilled;
      },
      createResourceFail(
        state,
        {
          payload: { errors },
        },
      ) {
        state[resource].creatingStatus = FETCH_STATUSES.failed;
        state[resource].errors = errors;
      },
    },
    actionCreators(restDispatch) {
      return {
        createResource: async (...params) => {
          restDispatch('createResourceStart');

          try {
            const data = await repository.create(...params);
            restDispatch('createResourceSuccess', data);

            return data;
          } catch (errors) {
            restDispatch('createResourceFail', { errors });
            throw errors;
          }
        },
      };
    },
    abstractSelector: state => {
      return {
        resource: state[resource],
      };
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/RestSlice/slices/createResourceSlice.js